<template>
  <v-container id="report-list">
    <app-city-header :payload="payload"> </app-city-header>

    <v-row>
      <v-col>Relatórios Administrativos</v-col>
      <v-col class="text-right">
        <v-btn
          v-if="
            isFullAdmin ||
            (groupsConfig.novoRelatorioAdministrativo &&
              config.novoRelatorioAdministrativo)
          "
          outlined
          color="primary"
          class="ml-3"
          :to="
            '/cidade/' +
            payload.municipioId +
            '/relatorio-administrativo/inserir'
          "
        >
          Novo Relatório Administrativo
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload.relatorios"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:top>
            <v-container>
              <v-row>
                <v-col>
                  <app-consultant-combobox
                    :filter="filter"
                  ></app-consultant-combobox>
                </v-col>

                <v-col>
                  <v-text-field
                    v-model="filter.dataInicialString"
                    v-mask="'##/##/####'"
                    label="Data Inicial"
                    clearable
                  ></v-text-field>
                </v-col>

                <v-col>
                  <v-text-field
                    v-model="filter.dataFinalString"
                    v-mask="'##/##/####'"
                    label="Data Final"
                    clearable
                  ></v-text-field>
                </v-col>

                <v-col>
                  <v-select
                    v-model="filter.statusRelatorioId"
                    item-text="text"
                    item-value="value"
                    :items="statusRelatorios"
                    label="Status dos Relatórios"
                  >
                  </v-select>
                </v-col>

                <v-col>
                  <v-btn
                    outlined
                    color="primary"
                    class="ml-3"
                    @click="getReports()"
                  >
                    <span>Filtrar</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </template>

          <template v-slot:item="props">
            <tr
              :class="{
                evidenciada:
                  props.item.statusRelatorioId === 2 ||
                  props.item.statusRelatorioId === 4,
                evidenciar: props.item.statusRelatorioId === 3,
                rejeitada:
                  props.item.statusRelatorioId === 1 ||
                  props.item.statusRelatorioId === 0,
              }"
            >
              <td>
                <a
                  :href="
                    './#/cidade/' +
                    props.item.municipioId +
                    '/relatorio-administrativo/obter/' +
                    props.item.relatorioAdministrativoId
                  "
                  >{{ props.item.titulo }}</a
                >
              </td>
              <td>{{ props.item.usuario.nome }}</td>
              <td>
                {{ props.item.criacao | moment("DD/MM/YYYY") }}
              </td>
            </tr>
          </template>

          <template slot="no-data">
            <span> Nenhum relatório administrativo retornado </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { AppCityHeader } from "@/modules/city";
import { administrativeReportAPI } from "@/modules/administrative-report";
import { mapActions, mapGetters } from "vuex";
import { AppConsultantCombobox } from "@/modules/user";

export default {
  components: {
    AppCityHeader,
    AppConsultantCombobox,
  },
  data() {
    return {
      headers: [
        { text: "Título", value: "titulo" },
        { text: "Criado por", value: "usuario.nome" },
        { text: "Criado em", value: "criacao" },
      ],
      payload: {
        municipioId: this.$route.params.id,
        relatorios: [],
      },
      filter: {
        statusRelatorioId: 1,
        usuarioId: null,
        dataInicialString: null,
        dataFinalString: null,
      },
      statusRelatorios: [
        { text: "Todos", value: null },
        { text: "Não Analisado", value: 1 },
        { text: "Aprovado", value: 2 },
        { text: "Reprovado", value: 3 },
        { text: "Inserido em Relatório Pagamento", value: 4 },
      ],
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    getReports() {
      this.setLoading(true);

      // Passar apenas os filtros que têm valor
      const filters = {};

      if (this.filter.usuarioId) {
        filters.usuarioId = this.filter.usuarioId;
      }

      if (this.filter.statusRelatorioId) {
        filters.statusRelatorioId = this.filter.statusRelatorioId;
      }

      if (this.filter.dataInicialString) {
        filters.dataInicialString = this.filter.dataInicialString;
      }

      if (this.filter.dataFinalString) {
        filters.dataFinalString = this.filter.dataFinalString;
      }

      administrativeReportAPI
        .getByCity(this.payload.municipioId, filters)
        .then((resp) => {
          this.payload.relatorios = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatórios administrativos");
        });
    },
  },
  computed: {
    ...mapGetters(["loading", "isFullAdmin"]),
  },
  mounted() {
    this.getReports();
  },
};
</script>
